import React, { useState } from "react";
import { db } from "../firebase";
import { toast } from "react-toastify";

const NewChat = ({ userEmail, buildChatId, openChat, startNewChat }) => {
  const [newChatForm, setNewChatForm] = useState({ email: "", msg: "" });

  const notification = (text) => {
    const raisetoast = (
      <p style={{ fontWeight: "700", color: "Black"}}>{text}</p>
    );
    toast(raisetoast);
  };
  const chatExists = async () => {
    const docId = buildChatId(newChatForm.email.replace("@gmail.com", ""));
    const chat = await db.collection("chats").doc(docId).get();
    return chat.exists;
  };

  const userExists = async () => {
    if (newChatForm.email !== userEmail) {
      const user = await db.collection("users").doc(newChatForm.email).get();
      return user.exists;
    }
  };

  const submitNewChat = async (e) => {
    e.preventDefault();
    const friend = await userExists();
    if (friend) {
      const conversation = await chatExists();
      conversation
        ? openChat([userEmail, newChatForm.email], newChatForm.msg)
        : startNewChat({
            sendTo: newChatForm.email,
            message: newChatForm.msg,
          });
    } else notification("User doesnot exist");
  };

  return (
    <div className="new__chat">
      <form className="new__chat-form" onSubmit={(e) => submitNewChat(e)}>
        <input
          autoFocus
          type="email"
          id="new__chat-email"
          placeholder="Your Friend's Email"
          onChange={(e) =>
            setNewChatForm({ email: e.target.value, msg: newChatForm.msg })
          }
          required
        />
        <input
          type="text"
          id="new__chat-msg"
          onChange={(e) =>
            setNewChatForm({ email: newChatForm.email, msg: e.target.value })
          }
          placeholder="Your Message"
          required
        />
        <button type="submit" className="new__chat-btn">
          Start Chat
        </button>
      </form>
    </div>
  );
};

export default NewChat;
